import { mobileIsUnsupportedFlag } from '@/common/services/mobile-fallback';
import { PREFIX_IN_BROWSER_TAB } from '@/common/platform-configuration/global-variables';
import { RouteConfig } from 'vue-router';
import { checkIfRouteAvailableByPlanFeatures } from '@/plan-features/routes';
import PlanFeaturesList from '@/plan-features/plan-features-list';
import { Permissions } from '@/permissions';

const API_OVERVIEW_PAGE = () => import('./pages/APITokensOverviewPage.vue');

export const enum AdminApiRoutes {
    Integrations = 'integrations',
}

const routes: RouteConfig[] = [
    {
        path: `${AdminApiRoutes.Integrations}`,
        name: AdminApiRoutes.Integrations,
        meta: {
            title: `${PREFIX_IN_BROWSER_TAB} | Integrations`,
            ...mobileIsUnsupportedFlag,
            showNavigationSidebar: true,
            requiredPermissions: [Permissions.AdminApi],
        },
        component: API_OVERVIEW_PAGE,
        beforeEnter: checkIfRouteAvailableByPlanFeatures(PlanFeaturesList.API),
    },
];

export default routes;
